import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AssessmentVitrineCard from "./AssessmentVitrineCard";
import InventoryVitrineCard from "./InventoryVitrineCard";
import TestVitrineCard from "./TestVitrineCard";
import VitrineInfoModal from "./VitrineInfoModal";
import "../Styles/VitrineCards.css";

const VitrineSection = () => {
  const { t } = useTranslation();
  const vitrineAssessments = useSelector((state) => state.landingPage.vitrineAssessments);
  const vitrineInventories = useSelector((state) => state.landingPage.vitrineInventories);
  const vitrineTests = useSelector((state) => state.landingPage.vitrineTests);

  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("assessments");
  const [hasAutoRotated, setHasAutoRotated] = useState(false);

  // Auto-rotate tabs on first load
  useEffect(() => {
    if (!hasAutoRotated) {
      const tabSequence = ["assessments", "inventories", "tests"];
      let currentIndex = 0;
      let loopCount = 0;
      const maxLoops = 2;

      const rotateInterval = setInterval(() => {
        currentIndex++;
        if (currentIndex >= tabSequence.length) {
          currentIndex = 0;
          loopCount++;
        }

        if (loopCount < maxLoops) {
          setActiveTab(tabSequence[currentIndex]);
        } else {
          // After two complete loops, go back to assessments and stop
          setActiveTab("assessments");
          setHasAutoRotated(true);
          clearInterval(rotateInterval);
        }
      }, 100); // 100ms per tab

      // Cleanup interval on unmount
      return () => clearInterval(rotateInterval);
    }
  }, [hasAutoRotated]);

  // Check if item should be marked as popular (first 3 items)
  const isPopular = (index) => index < 3;

  const handleSelectApplication = (application) => {
    setSelectedApplication(application);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedApplication(null);
  };

  const handleTabSelect = (key) => {
    setActiveTab(key);
    setHasAutoRotated(true); // Stop auto-rotation if user manually selects a tab
  };

  return (
    <div>
      <VitrineInfoModal show={showModal} onHide={handleCloseModal} application={selectedApplication} />

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        className="mb-4 vitrine-tabs"
        variant="pills"
        justify
      >
        {/* Assessments Tab */}
        <Tab eventKey="assessments" title={t("assessments")}>
          <Row className="g-4">
            {vitrineAssessments?.map((assessment, index) => (
              <Col xs={12} sm={6} md={6} lg={4} xl={3} key={`assessment-${assessment.id}`}>
                <AssessmentVitrineCard
                  assessment={assessment}
                  onSelect={handleSelectApplication}
                  isPopular={isPopular(index)}
                />
              </Col>
            ))}
          </Row>
        </Tab>

        {/* Inventories Tab */}
        <Tab eventKey="inventories" title={t("inventories")}>
          <Row className="g-4">
            {vitrineInventories?.map((inventory, index) => (
              <Col xs={12} sm={6} md={6} lg={4} xl={3} key={`inventory-${inventory.id}`}>
                <InventoryVitrineCard
                  inventory={inventory}
                  onSelect={handleSelectApplication}
                  isPopular={isPopular(index)}
                />
              </Col>
            ))}
          </Row>
        </Tab>

        {/* Tests Tab */}
        <Tab eventKey="tests" title={t("tests")}>
          <Row className="g-4">
            {vitrineTests?.map((test, index) => (
              <Col xs={12} sm={6} md={6} lg={4} xl={3} key={`test-${test.id}`}>
                <TestVitrineCard
                  test={test}
                  onSelect={handleSelectApplication}
                  isPopular={isPopular(index)}
                  isNew={false}
                />
              </Col>
            ))}
          </Row>
        </Tab>
      </Tabs>
    </div>
  );
};

export default VitrineSection;
